module.exports = __webpack_public_path__ + "img/banner_bg.a613038.jpg";